module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00559.8688f35a.jpg";